var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isUsingVePlayer
    ? _c("VePlayerVideo", {
        key: "veplayer",
        attrs: {
          videoPlayerReady: _vm.videoPlayerReady,
          isAnyPopupOpen: _vm.isAnyPopupOpen,
          "arena-id": _vm.arenaId,
          embedded: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "overlay",
              fn: function () {
                return [
                  _c("VideoToast", {
                    attrs: { toast: _vm.betVideoToast, source: _vm.arenaId },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1345420879
        ),
      })
    : _vm.isUsingV1Video
    ? _c("TCVideoV1", {
        key: "tcvideov1",
        attrs: {
          videoPlayerReady: _vm.videoPlayerReady,
          isAnyPopupOpen: _vm.isAnyPopupOpen,
          "arena-id": _vm.arenaId,
          embedded: "",
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c("VideoToast", {
                  attrs: { toast: _vm.betVideoToast, source: _vm.arenaId },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
    : _c("TCVideo", {
        key: "tcvideo",
        attrs: {
          videoPlayerReady: _vm.videoPlayerReady,
          isAnyPopupOpen: _vm.isAnyPopupOpen,
          "arena-id": _vm.arenaId,
          embedded: "",
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c("VideoToast", {
                  attrs: { toast: _vm.betVideoToast, source: _vm.arenaId },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }